import './index.css';
import { useScrollReveal } from './hooks';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import YourDesignRetreat from './components/YourDesignRetreat';
import Rooms from './components/Rooms';
import DiscoverEscape from './components/DiscoverEscape';
import Amenities from './components/Amenities';
import Experiences from './components/Experiences';
import Reviews from './components/Reviews';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';
import ProjectPage from './components/ProjectPage';

function HomePage() {
  return (
    <>
      <Hero />
      <YourDesignRetreat />
      <Rooms />
      <DiscoverEscape />
      <Amenities />
      <Experiences />
      <Reviews />
      <Newsletter />
    </>
  );
}

export default function App() {
  useScrollReveal();
  const path = window.location.pathname;
  return (
    <>
      <Navbar />
      {path === '/project' ? <ProjectPage /> : <HomePage />}
      <Footer />
    </>
  );
}
